import React from 'react';
import styled from 'styled-components';
import { ReactComponent as PDFIcon } from '@ubeya/shared-web/assets/compliance-pdf-file.svg';
import { ReactComponent as PPTXIcon } from '@ubeya/shared-web/assets/compliance-pptx-file.svg';
import { ReactComponent as DOCXIcon } from '@ubeya/shared-web/assets/compliance-docx-file.svg';
import { ReactComponent as XLSIcon } from '@ubeya/shared-web/assets/compliance-xlsx-file.svg';
import { ReactComponent as DefaultFileIcon } from '@ubeya/shared-web/assets/order.svg';
import { TextWithTooltip } from '@ubeya/shared-web/components';

const Doc = styled.div`
  display: flex;
  padding: 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 300;
  line-height: 1.71;
  font-size: 10px;
  padding: 2px;
  max-width: 150px;
  position: absolute;
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const DocumentWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  svg {
    height: 250px;
  }
`;

const EmployeeDocumentPreview = ({ title, extension }) => {
  const FileIcon = () => {
    switch (extension.toLowerCase()) {
      case 'pdf':
        return <PDFIcon />;
      case 'pptx':
        return <PPTXIcon />;
      case 'ppt':
        return <PPTXIcon />;
      case 'docx':
        return <DOCXIcon />;
      case 'xlsx':
        return <XLSIcon />;
      case 'xls':
        return <XLSIcon />;
      default:
        return <DefaultFileIcon />;
    }
  };
  return (
    <DocumentWrapper>
      <FileIcon />
      <Doc>
        <Title>
          <TextWithTooltip>{title}</TextWithTooltip>
        </Title>
      </Doc>
    </DocumentWrapper>
  );
};

export default EmployeeDocumentPreview;
